<template>
  <div class="ibox">
    <div class="ibox-title">
      <h2>Monthly Breakdown Report</h2>
    </div>
    <div class="ibox-content report-box" style="min-height: 125px">
      <div class="row">
        <div class="col-xs-12">
          <div class="m-b-md">
            <div class="radio radio-info radio-inline">
              <input
                type="radio"
                v-model="period"
                value="all_time"
                name="monthly_breakdown_period"
                id="monthly_breakdown_period_all_time">

              <label for="monthly_breakdown_period_all_time">All Time</label>
            </div>
            <div class="radio radio-info radio-inline">
              <input
                type="radio"
                v-model="period"
                value="date_range"
                name="monthly_breakdown_period"
                id="monthly_breakdown_period_range">
              <label for="monthly_breakdown_period_range">Date Range</label>
            </div>
          </div>

          <div v-show="periodSelectedIsDateRange">
            <div class="row">
              <div class="col-xs-6 col-md-6 form-group">
                <selectize
                  :options="months"
                  v-model="dateRange.monthFrom"
                  name="month_from">
                </selectize>
              </div>
              <div class="col-xs-6 col-md-6 form-group">
                <selectize
                  :options="years"
                  v-model="dateRange.yearFrom"
                  name="year_from">
                </selectize>
              </div>
              <div class="col-xs-12 text-center text-muted m-t-xs m-b-sm">
                through to
              </div>
              <div class="col-xs-6 col-md-6 form-group">
                <selectize
                  :options="months"
                  v-model="dateRange.monthTo"
                  name="month_to">
                </selectize>
              </div>
              <div class="col-xs-6 col-md-6 form-group">
                <selectize
                  :options="years"
                  v-model="dateRange.yearTo"
                  name="year_to">
                </selectize>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ibox-footer text-right">
      <ladda-button
        :on-click="handleGenerateReport"
        class="btn btn-primary btn-sm">
        <i class="fa fa-cloud-download fa-fw"></i> Download PDF
      </ladda-button>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { DateRange, Selectize, LaddaButton } from 'components/forms'
  import { notify } from 'utils'
  import { map } from 'lodash'
  import moment from 'moment'

  export default {
    components: {
      DateRange,
      Selectize,
      LaddaButton
    },

    data () {
      return {
        period: 'all_time',
        dateRange: {
          yearFrom: null,
          yearTo: null,
          monthFrom: null,
          monthTo: null
        }
      }
    },

    watch: {
      period () {
        if (this.period === 'all_time') {
          this.dateRange = {
            yearFrom: null,
            yearTo: null,
            monthFrom: null,
            monthTo: null
          }
        } else {
          this.dateRange = {
            yearFrom: moment().subtract(6, 'months').format('YYYY'),
            yearTo: moment().year(),
            monthFrom: moment().subtract(6, 'months').format('MMMM'),
            monthTo: moment().format('MMMM')
          }
        }
      }
    },

    computed: {
      months () {
        return map(moment.months(), month => ({ id: month, text: month }))
      },

      years () {
        const endingYear = 2000

        let years = []

        for (let year = moment().year(); year >= endingYear; year--) {
          years.push({ id: year, text: year })
        }

        return years
      },

      periodSelectedIsDateRange () {
        return this.period === 'date_range'
      },

      generatePayload () {
        return {
          from: this.periodSelectedIsDateRange
            ? moment(`1 ${this.dateRange.monthFrom} ${this.dateRange.yearFrom}`, 'D MMMM YYYY').format('YYYY-MM-DD')
            : null,
          to: this.periodSelectedIsDateRange
            ? moment(`1 ${this.dateRange.monthTo} ${this.dateRange.yearTo}`, 'D MMMM YYYY').format('YYYY-MM-DD')
            : null
        }
      }
    },

    methods: {
      ...mapActions('report', ['generateMonthlyBreakdownReport']),

      handleGenerateReport () {
        return this.validateAll().then(response => {
          const listenForReportGenerated = () => {
            notify.success('Please wait while we get your download ready.')
          }

          return this.generateMonthlyBreakdownReport(this.generatePayload).then(listenForReportGenerated)
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MonthlyBreakdownReport.vue?2cfe8cec